// extracted by css-extract-rspack-plugin
export default {"listItem":"list-item--o1VG3_RnSg4nXtr0"};